var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-right-panel"},[(_vm.singularityRightPanelState === 'ai_job_manager')?_c('AIJobManager'):_vm._e(),(_vm.singularityRightPanelState === 'debug')?_c('SingularityDebugPanel'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }